
const swiper = new Swiper('.product-review-slider', {
  slidesPerView: 1,      // 1 slide at a time
  spaceBetween: 20,      // space between slides
  autoHeight: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
    1024: {
      slidesPerView: 1,
    },
  },
});

(function () {

  function initPairsSwiper(scope) {
    var swiperEl = scope.querySelector('.pairs-swiper');
    if (!swiperEl) return;

    var prevEl = scope.querySelector('.pairs-prev'); 
    var nextEl = scope.querySelector('.pairs-next');

    var pairsSwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      autoHeight: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl
      },
      breakpoints: { 
        640: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 2
        },
        1200: {
          slidesPerView: 3
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.pairs-well-with-wrapper');
    sections.forEach(function (section) {
      initPairsSwiper(section);
    });
  });

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (event) {
    initPairsSwiper(event.target);
  });

})();

document.addEventListener('DOMContentLoaded', function () {
  var swiperContainers = document.querySelectorAll('.product-image-swiper');

  swiperContainers.forEach(function (container) {
    new Swiper(container, {
      spaceBetween: 8,
      loop: false,
      speed: 600,

      // Default (desktop)
      slidesPerView: 4.1,

      // Navigation arrows
      navigation: {
        nextEl: container.querySelector('.slider-next'),
        prevEl: container.querySelector('.slider-prev'),
      },

      // Responsive breakpoints
      breakpoints: {
        0: {
          slidesPerView: 2.2,
        },
        640: {
          slidesPerView: 3.2,
        },
        768: {
          slidesPerView: 3.5,
        },
        1024: {
          slidesPerView: 4.14,
        },
      },
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {

//   // FAQ ========================

    const FAQitems = document.querySelectorAll('.bundle-accordion .bundle-accordion-heading');
    if(FAQitems) {
      function toggleAccordion() {
          const isExpanded = this.classList.contains("active");
          FAQitems.forEach(item => {
              item.classList.remove('active');
              item.nextElementSibling.style.maxHeight = null;
              item.nextElementSibling.style.opacity = 0;
          });
          if (!isExpanded) {
              this.classList.add('active');
              const content = this.nextElementSibling;
              content.style.maxHeight = content.scrollHeight + "px";
              content.style.opacity = 1;
          }
      }
      FAQitems.forEach(item => item.addEventListener('click', toggleAccordion));
    }

});


document.addEventListener('DOMContentLoaded', function () {

  const MAX = 3;
  const slots = document.querySelectorAll(".slot");
  const products = document.querySelectorAll(".product");
  const kitBtn = document.getElementById("kitBtn");
  const addToCartBtn = document.querySelector(".add-to-cart");

  let kit = [];

  /***********************
   * UI UPDATE
   ***********************/
  function updateUI() {

    // Reset slots & product titles
    slots.forEach((slot, index) => {
      slot.classList.remove("filled");
      slot.innerHTML = "";
      slot.dataset.variantId = "";

      const productTitleDiv = slot.parentElement.querySelector(".product-title");
      if (productTitleDiv) {
        productTitleDiv.textContent = `Produkt #${index + 1}`;
      }
    });

    // Fill slots from kit
    kit.forEach((item, index) => {
      const slot = slots[index];
      if (!slot) return;

      slot.classList.add("filled");
      slot.dataset.variantId = item.variantId;

      slot.innerHTML = `<img src="${item.image}" alt="">
      <span class="remove">      
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z" fill="#E7E7E7"/>
        <path d="M10.6667 5.3335L5.33337 10.6668M5.33337 5.3335L10.6667 10.6668" stroke="#898989" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>`;

      const productTitleDiv = slot.parentElement.querySelector(".product-title");
      if (productTitleDiv) {
        productTitleDiv.textContent = item.title;
      }

      // Remove handler
      slot.querySelector(".remove").onclick = () => removeOne(item.variantId);
    });

    // Kit button state

    if(kitBtn) {
      kitBtn.disabled = kit.length !== MAX;
      kitBtn.textContent = `Välj ${MAX} produkter`;
    }

    const isKitFull = kit.length >= MAX;


      if (addToCartBtn) {
    if (isKitFull) {
      addToCartBtn.textContent = "Köp kit nu";
      addToCartBtn.disabled = false;
    } else {
      addToCartBtn.textContent = `Välj ${MAX} produkter`;
      addToCartBtn.disabled = true;
    }
  }

    // Update product blocks
    products.forEach(product => {
      const variantId = product.dataset.variantId;
      const image = product.dataset.image;
      const title = product.dataset.title;
      const price = product.dataset.price || "0 kr";
      const comparePrice = product.dataset.comparePrice || "0 kr";

      const qty = kit.filter(x => x.variantId === variantId).length;

      const count = product.querySelector(".count");
      const plus = product.querySelector(".plus");
      const minus = product.querySelector(".minus");
      const add = product.querySelector(".add");

      if (count) {
        count.textContent = qty;
        count.style.opacity = qty === 0 ? 0.5 : 1;
      }

      product.classList.toggle("active", qty > 0);

      if (plus) plus.disabled = isKitFull;
      if (add) add.disabled = isKitFull;

      [plus, add, minus].forEach(btn => {
        if (btn) btn.classList.toggle("disabled", btn.disabled);
      });

      // CLICK HANDLERS
      if (add) add.onclick = () => addOne(variantId, image, title, price, comparePrice);
      if (plus) plus.onclick = () => addOne(variantId, image, title, price, comparePrice);
      if (minus) minus.onclick = () => removeOne(variantId);
    });

    // ✅ Log total price and compare price for selected products with currency
    const totalPrice = kit.reduce((sum, item) => {
      // Extract number from price string
      const num = parseFloat(item.price.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
      return sum + num;
    }, 0);

    const totalComparePrice = kit.reduce((sum, item) => {
      const num = parseFloat(item.comparePrice.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
      return sum + num;
    }, 0);

    const currency = kit[0]?.price.replace(/[\d.,\s]/g, '') || 'kr';

    console.log(
      "Total Price:", totalPrice.toFixed(2) + " " + currency,
      "| Total Compare Price:", totalComparePrice.toFixed(2) + " " + currency
    );
    if(totalPrice > 0) {
      const priceElements = document.querySelectorAll(".bundle-block .price-block .price");
      // Loop through them and update the text
      priceElements.forEach(el => {
        el.textContent = totalPrice.toFixed(2) + " " + currency;
      });
    }

    const compriceElements = document.querySelectorAll(
  ".bundle-block .price-block .compare-price"
);

const discountElements = document.querySelectorAll(
  ".bundle-block .price-block .product-badge"
);

compriceElements.forEach((el, index) => {
  if (totalComparePrice > totalPrice) {
    // show compare price
    el.style.display = "inline";
    el.textContent = totalComparePrice.toFixed(2) + " " + currency;

    // calculate discount %
    const discountPercent = Math.round(
      ((totalComparePrice - totalPrice) / totalComparePrice) * 100
    );

    // show discount %
    if (discountElements[index]) {
      discountElements[index].style.display = "inline";
      discountElements[index].textContent = `SPARA ${discountPercent}%`;
    }
  } else {
    // hide compare price
    el.style.display = "none";

    // hide discount %
    if (discountElements[index]) {
      discountElements[index].style.display = "none";
    }
  }
});

  }

  /***********************
   * KIT ACTIONS
   ***********************/
  function addOne(variantId, image, title, price, comparePrice) {
    if (kit.length >= MAX) return;
    kit.push({ variantId, image, title, price, comparePrice });
    console.log("Added to kit:", title);
    updateUI();
  }

  function removeOne(variantId) {
    const index = kit.findIndex(item => item.variantId === variantId);
    if (index !== -1) {
      console.log("Removed from kit:", kit[index].title);
      kit.splice(index, 1);
      updateUI();
    }
  }

  /***********************
   * ADD TO CART
   ***********************/
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", () => {

      if (kit.length !== MAX) {
        alert("Please add products to your kit first!");
        return;
      }

      const variantMap = {};
      kit.forEach(item => {
        variantMap[item.variantId] = (variantMap[item.variantId] || 0) + 1;
      });
      
      const items = Object.keys(variantMap).map(id => ({
        id,
        quantity: variantMap[id]
      }));

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
        .then(res => res.json())
        .then(() => {
          console.log("Kit added to cart:", kit.map(i => i.title));
          document.querySelector("cart-drawer")?.classList.remove("is-empty");
          document.querySelector(".drawer__inner-empty")?.classList.add("hidden");
          document.querySelector(".drawer")?.classList.add("active", "animate");

          fetch(location.href)
            .then(res => res.text())
            .then(html => {
              const doc = new DOMParser().parseFromString(html, "text/html");
              const newDrawer = doc.querySelector("#CartDrawer");
              const currentDrawer = document.querySelector("#CartDrawer");
              if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
            });
        })
        .catch(err => console.error("Cart error:", err));
    });
  }

  /***********************
   * INIT
   ***********************/
  updateUI();
});


/* Review */
document.querySelectorAll(".bundle_kit_wrapper .bundle_kit_slide, .grid_pro_review").forEach(function (product) {
  const starsEl = product.querySelector(".jdgm-prev-badge .jdgm-prev-badge__stars");
  if (!starsEl) return;
  const dataScore = starsEl.getAttribute("data-score");
  if (!dataScore) return;
  const textEl = product.querySelector(".jdgm-prev-badge__text");
  if (!textEl) return;
  const reviewCount = textEl.textContent.replace(/Recensioner|anmeldelser|Anmeldelser|anmeldelse|Anmeldelse|reviews?|Reviews?/g, "").trim();
  textEl.textContent = `${dataScore} (${reviewCount})`;
});

/* Bundle sec review js */
document.querySelectorAll(".products .product, .pairs-well-with-wrapper .swiper-slide").forEach(function (product) {
  const starsEl = product.querySelector(
    ".jdgm-widget-review-block .jdgm-prev-badge__stars"
  );
  if (!starsEl) return;

  const dataScore = starsEl.getAttribute("data-score");
  if (!dataScore) return;

  const textEl = product.querySelector(".jdgm-prev-badge__text");
  if (!textEl) return;

  // remove "reviews" and keep only number
  // const reviewCount = textEl.textContent.replace("Recensioner", "").trim();
  const reviewCount = textEl.textContent.replace(/Recensioner|anmeldelser|Anmeldelser|anmeldelse|Anmeldelse|reviews?|Reviews?/g, "").trim();

  // format: 4.03 (30)
  textEl.textContent = `${dataScore} (${reviewCount})`;
});
/* End review js */

document.querySelectorAll(".jdgm-widget-review-block").forEach(function(block) {
  const badgeText = block.textContent.trim();

  if (badgeText === "0.00 (No)" || badgeText === "" || badgeText.toLowerCase().includes("no")) {
    block.style.opacity = "0";
    block.style.visibility = "hidden";
  }
});

document.addEventListener("DOMContentLoaded", function () {
 var cat_slider = new Swiper(".category-grid-slider", {
      spaceBetween: 24,
      loop: true,
      navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 16},
        575: { slidesPerView: 1.3, spaceBetween: 16},
        600: { slidesPerView: 2.5,spaceBetween: 20 },
        989: { slidesPerView: 3.9, spaceBetween: 20},
        1024: { slidesPerView: 4.9 },
        1440: { slidesPerView: 5 },
      },
    });


    /* Home page animation section js */
     const section = document.querySelector(".sc-home-img-text");

  // 🔒 Safety check
  if (!section) return;

  const images = section.querySelectorAll(".image-wrapper");

  function animateOnScroll() {
    const rect = section.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView) {
      images.forEach((img, i) => {
        setTimeout(() => {
          img.classList.add("active");
        }, i * 300);
      });
      window.removeEventListener("scroll", animateOnScroll);
    }
  }

  window.addEventListener("scroll", animateOnScroll);
  animateOnScroll(); // also check on load
    /* End Home page animation section js */

});

// collection page pagination 
let collectionState = {
  initialized: false,
  currentPage: 0,
  itemsLength: 0
};

function collectionTabbing() {
  const grid = document.querySelector(".template-collection #product-grid");
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll(".grid__item"));
  const itemsPerPage = 4;
  const totalPages = Math.ceil(items.length / itemsPerPage);

  // 🔁 If nothing changed, just update view
  if (
    collectionState.initialized &&
    collectionState.itemsLength === items.length
  ) {
    updateView(items, itemsPerPage, totalPages);
    return;
  }

  // 🆕 reset only when items change
  collectionState.itemsLength = items.length;
  collectionState.currentPage = 0;
  collectionState.initialized = true;

  // remove old pagination
  const oldPagination = document.querySelector(".product-grid-pagination");
  if (oldPagination) oldPagination.remove();

  if (items.length <= itemsPerPage) {
    items.forEach(item => (item.style.display = "block"));
    return;
  }

  // create pagination
  const pagination = document.createElement("div");
  pagination.className = "product-grid-pagination";
  pagination.style.display = "flex";
  pagination.style.justifyContent = "center";
  pagination.style.gap = "8px";
  pagination.style.marginTop = "20px";

  const prevBtn = document.createElement("button");
  prevBtn.innerText = "Prev";

  const nextBtn = document.createElement("button");
  nextBtn.innerText = "Next";

  pagination.appendChild(prevBtn);

  for (let i = 0; i < totalPages; i++) {
    const btn = document.createElement("button");
    btn.innerText = i + 1;

    btn.addEventListener("click", () => {
      collectionState.currentPage = i;
      updateView(items, itemsPerPage, totalPages);
    });

    pagination.appendChild(btn);
  }

  pagination.appendChild(nextBtn);
  grid.after(pagination);

  prevBtn.addEventListener("click", () => {
    if (collectionState.currentPage > 0) {
      collectionState.currentPage--;
      updateView(items, itemsPerPage, totalPages);
    }
  });

  nextBtn.addEventListener("click", () => {
    if (collectionState.currentPage < totalPages - 1) {
      collectionState.currentPage++;
      updateView(items, itemsPerPage, totalPages);
    }
  });

  updateView(items, itemsPerPage, totalPages);
}

function updateView(items, itemsPerPage, totalPages) {
  items.forEach((item, index) => {
    item.style.display =
      index >= collectionState.currentPage * itemsPerPage &&
      index < (collectionState.currentPage + 1) * itemsPerPage
        ? "block"
        : "none";
  });

  const buttons = document.querySelectorAll(
    ".product-grid-pagination button"
  );

  buttons.forEach((btn, index) => {
    if (btn.innerText === "Prev" || btn.innerText === "Next") return;
    btn.style.fontWeight =
      index - 1 === collectionState.currentPage ? "bold" : "normal";
  });

  const prevBtn = document.querySelector(
    ".product-grid-pagination button:first-child"
  );
  const nextBtn = document.querySelector(
    ".product-grid-pagination button:last-child"
  );

  if (prevBtn) prevBtn.disabled = collectionState.currentPage === 0;
  if (nextBtn)
    nextBtn.disabled =
      collectionState.currentPage === totalPages - 1;
}

// 🔁 interval stays
setInterval(collectionTabbing, 500);

// const updateUI = debounce(() => {
//   const filterList = document.querySelector('.collection-filter-list');
//   if (filterList && filterList.querySelector('facet-remove')) {
//     const container = document.querySelector('.problemomraden-filtrera-och-sortera');
//     const grid = document.getElementById('product-grid');
    
//     if (!container || !grid) return;
    
//     const collGridCount = grid.children.length;
    
//     let countDiv = container.querySelector('.grid-count');
//     if (!countDiv) {
//       countDiv = document.createElement('div');
//       countDiv.className = 'grid-count';
//       container.appendChild(countDiv);
//     }
    
//     countDiv.textContent = `Resultat (${collGridCount})`;
//     document.querySelector('.problemomraden-filtrera-och-sortera .grid-count').style.display = "block"
//   }else {
//     document.querySelector('.problemomraden-filtrera-och-sortera + .active-facets .active-facets__button-wrapper').style.display = "none"
//     let filterColleHide = document.querySelector('.problemomraden-filtrera-och-sortera .grid-count')
//     if(filterColleHide) {
//       filterColleHide.style.display = "none"
//     }
//   }
// }, 10);
// setInterval(updateUI, 500);

const updateUI = debounce(() => {
  const filterList = document.querySelector('.collection-filter-list');

  if (filterList && filterList.querySelector('facet-remove')) {
    const container = document.querySelector('.problemomraden-filtrera-och-sortera');
    const grid = document.getElementById('product-grid');
    
    if (!container || !grid) return;
    
    const collGridCount = grid.children.length;
    
    let countDiv = container.querySelector('.grid-count');
    if (!countDiv) {
      countDiv = document.createElement('div');
      countDiv.className = 'grid-count';
      container.appendChild(countDiv);
    }
    
    countDiv.textContent = `Resultat (${collGridCount})`;
    countDiv.style.display = "block";

  } else {
    const btnWrapper = document.querySelector('.problemomraden-filtrera-och-sortera + .active-facets .active-facets__button-wrapper');
    if (btnWrapper) {
      btnWrapper.style.display = "none";
    }
    let filterColleHide = document.querySelector('.problemomraden-filtrera-och-sortera .grid-count');
    if (filterColleHide) {
      filterColleHide.style.display = "none";
    }
  }
}, 10);

setInterval(updateUI, 500);

setInterval(function () {
    const body = document.body;

    if (body.classList.contains("upcartPopupShow")) {
      body.classList.add("overflow-hidden");
    } else {
      body.classList.remove("overflow-hidden");
    }
  }, 200);